<template>
<div>
    <div v-if="list && list!=''" class="model-box ptn bcw">
        <div class="model-box__bd clear">
            <my-cycle-card v-for="(item,index) in list" :key="index" :course="item" :type="cardType"></my-cycle-card>
        </div>   
    </div>
    <div v-else class="tac norecord">
        <i class="iconfont">&#xe646;</i><br/>
        暂无记录，请先购买{{cardName}}
    </div>    
</div>
</template>
<script>
import Vue from 'vue';
import MyCycleCard from '@/components/MyCycleCard'
export default {
    name: 'MyCycleList',
    components: {
        MyCycleCard
    },
    data(){
      return {
        list:{},  // 卡列表
        total:0,   // 总数
        cardType:{},
        cardName:'',
      }
    },
    created(){
        // 取团课列表数据
        let _this = this;
        _this.cardType=this.$route.params.cardType;
        if(_this.cardType=='MONTH_CARD'){
            _this.cardName ='月卡'
        }else{
            _this.cardName ='练球卡'
        }
        this.$http.get('product/getUserClubCardList?clubId=' + this.$route.params.clubId+'&cardType='+this.$route.params.cardType).then(function(res){
            if(!res.data.code){
                _this.list = res.data.value
                _this.total = res.data.value.length
            }else{
                alert(res.data.message)
            }
          
        })
    },
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/MyCardList.vue